export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      5011.156462585034,
    ],
    button_spin: [
      7000,
      854.7845804988663,
    ],
    end_free_spin: [
      9000,
      2520.816326530612,
    ],
    fire_ball_fs_01: [
      13000,
      883.8095238095232,
    ],
    fire_ball_fs_02: [
      15000,
      988.2993197278918,
    ],
    fire_ball_fs_03: [
      17000,
      927.3469387755107,
    ],
    fire_ball_fs_04: [
      19000,
      1159.546485260769,
    ],
    fire_ball_fs_05: [
      22000,
      1049.2517006802727,
    ],
    free_bet_big_win: [
      25000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      28000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      32000,
      979.5918367346915,
    ],
    free_bet_ultra_win: [
      34000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      37000,
      36992.2902494331,
    ],
    free_spin_music: [
      75000,
      32010.158730158735,
    ],
    free_spin_popup: [
      109000,
      5112.743764172336,
    ],
    free_spin_start: [
      116000,
      6296.961451247171,
    ],
    inside_buttons: [
      124000,
      480.3628117913803,
    ],
    main_ambient: [
      126000,
      78921.72335600907,
    ],
    main_music: [
      206000,
      149343.492063492,
    ],
    mega_win: [
      357000,
      4874.739229024954,
    ],
    outside_buttons: [
      363000,
      515.1927437641461,
    ],
    reel_stop_01: [
      365000,
      230.74829931971408,
    ],
    reel_stop_02: [
      367000,
      155.2834467120192,
    ],
    reel_stop_03: [
      369000,
      207.5283446711751,
    ],
    reel_stop_04: [
      371000,
      216.2358276643772,
    ],
    reel_stop_05: [
      373000,
      187.21088435376032,
    ],
    regular_win: [
      375000,
      1853.2426303854663,
    ],
    scatter_stop: [
      378000,
      1975.1473922902392,
    ],
    t_rex_scream: [
      381000,
      4146.213151927441,
    ],
    tap_to_play: [
      387000,
      7353.469387755126,
    ],
    ultra_win: [
      396000,
      5150.476190476184,
    ],
    wild_expanding: [
      403000,
      2880.725623582748,
    ],
    wild_stop: [
      407000,
      2097.052154195012,
    ],
  },
}
